export default {
  state: {
    serviceEta: {
      shared: 999,
      opoli: 999,
      black: 999,
      suv: 999,
      shuttle: 999
    }
  },
  mutations: {
    resetServiceEta (state) {
      state.erviceEta = {
        shared: 999,
        opoli: 999,
        black: 999,
        suv: 999,
        shuttle: 999
      }
    },
    setServiceEta (state, data) { state.serviceEta[data.service] = data.value }
  }
}



// WEBPACK FOOTER //
// ./src/store/reservation/service-eta.js